import React from 'react';
import { Card } from 'antd';
import { useLocation } from 'react-router-dom';
import {
  SkBar,
  SkHeader,
  SkStatCards,
  SkTabsBar,
  SkAlertBanner,
  SkTable,
} from './_primitives';

const FilterBar = () => (
  <Card className="shadow-sm mb-4">
    <div className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center">
      <SkBar h="h-10" w="w-full" className="rounded-md flex-1" />
      <SkBar h="h-10" w="w-full sm:w-24" className="rounded-md flex-shrink-0" />
    </div>
    <SkBar h="h-3" w="w-20" className="mt-3" />
  </Card>
);

const LogTabContent = () => (
  <>
    <SkAlertBanner />
    <SkStatCards count={3} />
    <FilterBar />
    <Card className="shadow-sm">
      <div className="overflow-x-auto">
        <SkTable rows={6} cols={7} inCard={false} />
      </div>
      <div className="flex justify-center mt-4">
        <SkBar h="h-8" w="w-72" className="rounded-md" />
      </div>
    </Card>
  </>
);

/* ─────── Config tab skeleton (4 grouped cards, matches FraudConfigPanel) ─────── */

const CONFIG_FIELD_COUNTS = [1, 3, 3, 1];

const FieldSkeleton = () => (
  <div className="flex flex-col gap-2">
    <SkBar h="h-3" w="w-40" />
    <SkBar h="h-3" w="w-56" className="max-w-full" />
    <SkBar h="h-10" w="w-full" className="rounded-md mt-1" />
  </div>
);

const ConfigGroupCard = ({ fields }) => (
  <Card className="shadow-sm" styles={{ body: { padding: 20 } }}>
    <div className="flex flex-col gap-2 pb-4 mb-4 border-b border-gray-100">
      <SkBar h="h-4" w="w-40" />
      <SkBar h="h-3" w="w-72" className="max-w-full" />
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {Array.from({ length: fields }).map((_, i) => (
        <FieldSkeleton key={i} />
      ))}
    </div>
  </Card>
);

const ConfigTabContent = () => (
  <>
    <SkAlertBanner />
    <div className="flex flex-col gap-4">
      {CONFIG_FIELD_COUNTS.map((count, idx) => (
        <ConfigGroupCard key={idx} fields={count} />
      ))}
    </div>
    <div className="flex items-center justify-end gap-2 mt-5">
      <SkBar h="h-10" w="w-24" className="rounded-md" />
      <SkBar h="h-10" w="w-32" className="rounded-md" />
    </div>
  </>
);

const FraudDetectionPageLoader = () => {
  const { search } = useLocation();
  const tab = new URLSearchParams(search).get('tab');
  const isConfig = tab === 'config';

  return (
    <div className="w-full p-3 sm:p-4 md:p-6">
      <SkHeader withAvatar={false} actions={0} />
      <SkTabsBar tabs={2} />
      {isConfig ? <ConfigTabContent /> : <LogTabContent />}
    </div>
  );
};

export default FraudDetectionPageLoader;
